export default __webpack_public_path__ + "static/media/insurance.5b96ef9f.svg";